<div class="theme-interface">
    <div class="border mb-3">
        <div class="row mx-0 py-2 border-bottom">
            <div class="col-6 my-auto">
                <div class="d-flex font-size-primary font-weight-bold">
                    <span class="pr-5 theme-color-header">Thu 30 Aug</span>
                    <span class="theme-color-header">XT-34</span>
                </div>
            </div>
            <div class="col-6 justify-content-end d-flex">
                <button class="btn">Reorder</button>
                <span class="icon-button container-theme-light-icons font-size-primary ml-3 my-auto">
                    <i class="fas fa-chevron-down"></i>
                </span>
            </div>
        </div>
        <div class="row p-3">
            <div class="col-6">
                <img class="img-fluid pr-3"
                    src="https://admin.testgodev.nl/api/v1/files/stores/1006/content-items/189427/picture/content-item.jpg"
                    alt="">
                <span>1 x Kheer (€32,00)</span>
            </div>
            <div class="col-6 d-flex">
                <span class="align-content-center">€32</span>
            </div>
        </div>
    </div>
    <div class="border">
        <div class="row mx-0 py-2 border-bottom">
            <div class="col-6 my-auto">
                <div class="d-flex font-size-primary font-weight-bold">
                    <span class="pr-5 theme-color-header">Thu 30 Aug</span>
                    <span class="theme-color-header">XT-34</span>
                </div>
            </div>
            <div class="col-6 justify-content-end d-flex">
                <button class="btn">Reorder</button>
                <span class="icon-button container-theme-light-icons font-size-primary ml-3 my-auto">
                    <i class="fas fa-chevron-down"></i>
                </span>
            </div>
        </div>
        <div class="row p-3">
            <div class="col-6">
                <img class="img-fluid pr-3"
                    src="https://admin.testgodev.nl/api/v1/files/stores/1006/content-items/189427/picture/content-item.jpg"
                    alt="">
                <span>1 x Chole Ruti (€ 11,00)</span>
            </div>
            <div class="col-6 d-flex">
                <span class="align-content-center">€11</span>
            </div>
        </div>
        <div class="row px-3 pb-3">
            <div class="col-6">
                <span>1 x Ruti sobji (€ 21,00)</span>
            </div>
            <div class="col-6 d-flex">
                <span class="align-content-center">€21</span>
            </div>
        </div>
    </div>
</div>